import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { TherapistAction } from 'src/redux/actions/constant';
import therapistService from 'src/services/apiServices/therapist-scheduling/therapistService';

const {
  REQUEST_GET_ALL_THERAPIST,
  FAILURE_GET_ALL_THERAPIST,
  SUCCESS_GET_ALL_THERAPIST,
  LOADING_GET_ALL_THERAPIST,
} = TherapistAction;

function* getAllTherapists(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_GET_ALL_THERAPIST });
    const response = yield call(therapistService.getAllTherapists, action.payload);
    if (response?.status === 200) {
      yield put({
        type: SUCCESS_GET_ALL_THERAPIST,
        payload: response.data,
        requestedPage: action?.payload?.page ?? 0,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_ALL_THERAPIST, payload: error });
  }
}

function* getAllTherapistsByDiscipline() {
  yield takeEvery(REQUEST_GET_ALL_THERAPIST, getAllTherapists);
}

export default getAllTherapistsByDiscipline;
